<template>
  <nav class="navbar-default navbar-static-side" role="navigation">
    <div class="sidebar-collapse">
      <ul class="nav metismenu" id="side-menu">
        <li class="nav-header">
          <div class="profile-element">
            <a>
              <span class="clear">
                <span class="block m-t-xs">
                  <strong class="font-bold">
                    <a class="user-name">{{ userData }}</a>
                  </strong>
                </span>
              </span>
            </a>
          </div>
          <div class="logo-element">
            <span>CP</span>
          </div>
        </li>

        <li :class="{ active: selectedMenu.includes('dashboard') }">
          <a class="navlink" @click="selectMenu('dashboard')">
            <i class="fa fa-laptop"></i>
            <router-link to="/" class="menu-item">Dashboard</router-link>
          </a>
        </li>

        <li
          v-if="canViewSaleMenu"
          :class="{ active: selectedMenu.includes('sale') }"
        >
          <a class="navlink" @click="selectMenu('sale')">
            <i class="fa fa-shopping-cart"></i>
            <span class="nav-label">Sprzedaż</span>
            <i class="arrow fas fa-angle-left"></i>
          </a>
          <ul v-if="selectedMenu.includes('sale')" class="nav nav-second-level">
            <li v-if="canViewOrders">
              <router-link to="/order/list" class="submenu__item">
                Zamówienia
              </router-link>
            </li>
            <li v-if="canViewInvoices">
              <router-link to="/invoices/list" class="submenu__item">
                Faktury
              </router-link>
            </li>
            <li v-if="canViewInvoices">
              <router-link to="/invoices/legacy_list" class="submenu__item">
                Faktury - legacy
              </router-link>
            </li>
            <li v-if="canImportPayments">
              <router-link to="/payment/import" class="submenu__item">
                Import wpłat
              </router-link>
            </li>
          </ul>
        </li>

        <li
          v-if="canViewCrmMenu"
          :class="{ active: selectedMenu.includes('crm') }"
        >
          <a class="navlink" @click="selectMenu('crm')">
            <i class="fa fa-th-large"></i>
            <span class="nav-label">CRM</span>
            <i class="arrow fas fa-angle-left"></i>
          </a>
          <ul v-if="selectedMenu.includes('crm')" class="nav nav-second-level">
            <li v-if="canViewClients">
              <router-link to="/clients/list" class="submenu__item">
                Klienci
              </router-link>
            </li>
            <li v-if="canViewMessages">
              <router-link to="/messages/list" class="submenu__item">
                Sprawy
              </router-link>
            </li>
            <li v-if="canViewDiscountGroups">
              <router-link to="/discount-groups/list" class="submenu__item">
                Grupy rabatowe
              </router-link>
            </li>
          </ul>
        </li>

        <li
          v-if="canViewProductionMenu"
          :class="{ active: selectedMenu.includes('production') }"
        >
          <a class="navlink" @click="selectMenu('production')">
            <i class="fa fa-refresh"></i>
            <span class="nav-label">Produkcja</span>
            <i class="arrow fas fa-angle-left"></i>
          </a>
          <ul
            v-if="selectedMenu.includes('production')"
            class="nav nav-second-level"
          >
            <li v-if="canViewMontages">
              <router-link to="/montages/list" class="submenu__item">
                Montaże
              </router-link>
            </li>
            <li v-if="canViewMontages">
              <router-link to="/montages/list-archive" class="submenu__item">
                Montaże - archiwum
              </router-link>
            </li>
            <li v-if="canViewCubes">
              <router-link to="/cubes/list" class="submenu__item">
                Kostki produkcyjne
              </router-link>
            </li>
            <li v-if="canSendOrders">
              <router-link to="/order/send" class="submenu__item">
                Wysyłka zamówień
              </router-link>
            </li>
          </ul>
        </li>

        <li
          v-if="canViewProductsMenu"
          :class="{ active: selectedMenu.includes('products') }"
        >
          <a class="navlink" @click="selectMenu('products')">
            <i class="fa fa-th-large"></i>
            <span class="nav-label">Produkty</span>
            <i class="arrow fas fa-angle-left"></i>
          </a>
          <ul
            v-if="selectedMenu.includes('products')"
            class="nav nav-second-level"
          >
            <li v-if="canViewCategories">
              <router-link to="/categories/list" class="submenu__item">
                Kategorie
              </router-link>
            </li>
            <li v-if="canViewProducts">
              <router-link to="/products" class="submenu__item">
                Produkty
              </router-link>
            </li>
            <li v-if="canViewParameters">
              <router-link to="/parameters" class="submenu__item">
                Parametry produktów
              </router-link>
            </li>
            <li v-if="canViewFormatGroups">
              <router-link to="/format-groups" class="submenu__item">
                Grupy formatów
              </router-link>
            </li>
            <li v-if="canViewFormats">
              <router-link to="/format/list" class="submenu__item">
                Formaty
              </router-link>
            </li>
            <li v-if="canViewOptionGroups">
              <router-link
                to="/product-option-group/list"
                class="submenu__item"
              >
                Grupy opcji
              </router-link>
            </li>
            <li v-if="canViewExclusions">
              <router-link
                to="/product-option-exclusion/list"
                class="submenu__item"
              >
                Wykluczenia opcji
              </router-link>
            </li>
            <li v-if="canViewAppliances">
              <router-link to="/appliances" class="submenu__item">
                Zastosowania
              </router-link>
            </li>
            <li v-if="canViewDiscounts">
              <router-link to="/discount/list" class="submenu__item">
                Rabaty
              </router-link>
            </li>
          </ul>
        </li>

        <li
          v-if="canViewContentsMenu"
          :class="{ active: selectedMenu.includes('contents') }"
        >
          <a class="navlink" @click="selectMenu('contents')">
            <i class="fa fa-th-large"></i>
            <span class="nav-label">Treści w serwisie</span>
            <i class="arrow fas fa-angle-left"></i>
          </a>
          <ul
            v-if="selectedMenu.includes('contents')"
            class="nav nav-second-level"
          >
            <li v-if="canViewNews">
              <router-link to="/news/list" class="submenu__item">
                Aktualności
              </router-link>
            </li>
            <li v-if="canViewBanners">
              <router-link to="/banners/list" class="submenu__item">
                Banery
              </router-link>
            </li>
            <li v-if="canViewPages">
              <router-link to="/pages" class="submenu__item">
                Strony
              </router-link>
            </li>
            <li v-if="canViewFaq">
              <router-link to="/faq" class="submenu__item">Faq</router-link>
            </li>
            <li v-if="canViewTranslations">
              <router-link to="/translations" class="submenu__item">
                Tłumaczenia
              </router-link>
            </li>
            <li v-if="canViewI18nTranslations">
              <router-link to="/i18n/translations" class="submenu__item">
                Nowe tłumaczenia
              </router-link>
            </li>
            <li v-if="canViewTranslations">
              <router-link to="/translations/models-list" class="submenu__item">
                Tłumaczenia Modeli
              </router-link>
            </li>
            <li v-if="canViewFiles">
              <router-link to="/file/list" class="submenu__item">
                Pliki
              </router-link>
            </li>
          </ul>
        </li>

        <li
          v-if="canViewLogsMenu"
          :class="{ active: selectedMenu.includes('logs') }"
        >
          <a class="navlink" @click="selectMenu('logs')">
            <i class="fa fa-area-chart"></i>
            <span class="nav-label">Logi i statystyki</span>
            <i class="arrow fas fa-angle-left"></i>
          </a>
          <ul v-if="selectedMenu.includes('logs')" class="nav nav-second-level">
            <li v-if="canViewStats">
              <router-link to="/montagelogs" class="submenu__item">
                <span>Statystki montaży</span>
              </router-link>
            </li>
            <li v-if="canViewStats">
              <router-link to="/cubelogs" class="submenu__item">
                <span>Statystyki kostek i wysyłki</span>
              </router-link>
            </li>
            <li v-if="canViewSystemLogs">
              <router-link to="/systemlogs" class="submenu__item">
                <span>Logi systemowe</span>
              </router-link>
            </li>
            <li v-if="canViewProductionLogs">
              <router-link to="/productionlogs" class="submenu__item">
                <span>Logi produkcyjne</span>
              </router-link>
            </li>
            <li v-if="canViewStats">
              <a class="navlink" @click="selectMenu('stats')">
                <span class="nav-label">Statystyki</span>
                <i class="arrow fas fa-angle-left"></i>
              </a>
              <ul
                v-if="selectedMenu.includes('stats')"
                class="nav nav-three-level"
              >
                <li>
                  <router-link to="/overall" class="submenu__item">
                    <span>Klienci</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/productlogs" class="submenu__item">
                    <span>Zamawiane produkty</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/packagelogs" class="submenu__item">
                    <span>Przesyłki/paczki</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/salelogs" class="submenu__item">
                    <span>Sprzedaży</span>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </li>

        <li
          v-if="canViewConfigurationMenu"
          :class="{ active: selectedMenu.includes('configuration') }"
        >
          <a class="navlink" @click="selectMenu('configuration')">
            <i class="fa fa-gears"></i>
            <span class="nav-label">Konfiguracja</span>
            <i class="arrow fas fa-angle-left"></i>
          </a>
          <ul
            v-if="selectedMenu.includes('configuration')"
            class="nav nav-second-level"
          >
            <li v-if="canViewAdmins">
              <router-link to="/admins" class="submenu__item">
                Użytkownicy
              </router-link>
            </li>
            <li v-if="canViewGroups">
              <router-link to="/groups" class="submenu__item">
                Grupy uprawnień
              </router-link>
            </li>
            <li v-if="canViewCompetencies">
              <router-link to="/competencies" class="submenu__item">
                Kompetencje
              </router-link>
            </li>
            <li v-if="canViewIps">
              <router-link to="/ips" class="submenu__item">
                Dozwolone adresy IP
              </router-link>
            </li>
            <li v-if="canViewSettings">
              <router-link to="/settings" class="submenu__item">
                Ustawienia
              </router-link>
            </li>
            <li v-if="canViewHolidays">
              <router-link to="/holidays" class="submenu__item">
                Dni wolne
              </router-link>
            </li>
            <li v-if="canViewPackages">
              <router-link to="/packages" class="submenu__item">
                Grupy pakowania
              </router-link>
            </li>
            <li v-if="canViewMachines">
              <router-link to="/machines" class="submenu__item">
                Maszyny
              </router-link>
            </li>
            <li v-if="canViewProcesses">
              <router-link to="/processes" class="submenu__item">
                Procesy
              </router-link>
            </li>
            <li v-if="canViewCosts">
              <router-link to="/costs" class="submenu__item">
                Baza kosztów stałych
              </router-link>
            </li>
            <li v-if="canViewPlates">
              <router-link to="/plates" class="submenu__item">
                Maszyny drukujące
              </router-link>
            </li>
            <li v-if="canViewVariables">
              <router-link to="/variables" class="submenu__item">
                <span>Zmienne pdfToolbox</span>
              </router-link>
            </li>
            <li v-if="canViewTrackingTags">
              <router-link to="/tracking-tags" class="submenu__item">
                Tagi - Ecommerce
              </router-link>
            </li>
            <li v-if="canViewKsefCompanies">
              <router-link to="/ksef/companies" class="submenu__item">
                KSeF sprzedawcy
              </router-link>
            </li>
            <li v-if="canViewDynamicPrices">
              <router-link to="/dynamic-prices" class="submenu__item">
                Dynamiczne ceny
              </router-link>
            </li>
          </ul>
        </li>

        <li
          v-if="canViewAllegroMenu"
          :class="{ active: selectedMenu.includes('allegro') }"
        >
          <a class="navlink" @click="selectMenu('allegro')">
            <i class="fa-brands fa-buysellads"></i>
            <span class="nav-label"> Allegro</span>
            <i class="arrow fas fa-angle-left"></i>
          </a>
          <ul
            v-if="selectedMenu.includes('allegro')"
            class="nav nav-second-level"
          >
            <li v-if="canViewAllegroAccounts">
              <router-link to="/allegro/accounts/list" class="submenu__item">
                Moje konta
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { computed, ref } from "vue";
import { useCookies } from "vue3-cookies";
import { hasPermission } from "../../permissions";
import { ksefCompanyPermissionsConst } from "../../constants/ksefConstants";
import {
  invoicePermissionsConst,
  orderPermissionsConst,
  paymentImportPermissionsConst,
} from "../../constants/orderConstants";
import { modelPermissionsGroupPermissionsConst } from "../../constants/groupConstants";
import { adminPermissionsConst } from "../../constants/userConstants";
import { clientPermissionsConst } from "../../constants/clientConstants";
import { allowedIpPermissionsConst } from "../../constants/ipConstants";
import { discountGroupPermissionsConst } from "../../constants/discountGroupConstants";
import {
  bannerPermissionsConst,
  clientcontactPermissionsConst,
  faqPermissionsConst,
  settingPermissionsConst,
  systemLogPermissionsConst,
  variablePermissionsConst,
} from "../../constants/settingConstants";
import { newsPermissionsConst } from "../../constants/newsConstants";
import { pagePermissionsConst } from "../../constants/pageConstants";
import { costPermissionsConst } from "../../constants/costConstants";
import { trackingTagPermissionsConst } from "../../constants/tagsConstants";
import {
  appliancesPermissionsConst,
  competencePermissionsConst,
  holidayPermissionsConst,
  machinePermissionsConst,
  montagePermissionsConst,
  platePermissionsConst,
} from "../../constants/productionConstants";
import {
  categoryPermissionsConst,
  discountPermissionsConst,
  exclusionPermissionsConst,
  packagePermissionsConst,
  productOptionGroupPermissionsConst,
  productParameterPermissionsConst,
  productPermissionsConst,
  turnoverDiscountSettingPermissionsConst,
} from "../../constants/productConstants";
import {
  formatGroupPermissionsConst,
  formatPermissionsConst,
} from "../../constants/formatConstants";
import { statsPermissionsConst } from "../../constants/statsConstants";
import { allegroAccountPermissionsConst } from "../../constants/allegroConstants";
import { filePermissionsConst } from "../../constants/fileConstants";
import {
  processPermissionsConst,
  processStagePermissionsConst,
} from "../../constants/processConstants";
import {
  translationPermissionsConst,
  i18nTranslationPermissionsConst,
} from "../../constants/translationConstants";
export default {
  name: "NavigationPage",
  mixins: [],
  components: {},

  props: {},

  setup() {
    const { cookies } = useCookies();
    const selectedMenu = ref([]);
    const userData = ref(cookies.get("CPadmin"));
    const canViewKsefCompanies = computed(() =>
      hasPermission(ksefCompanyPermissionsConst.view)
    );
    const canViewGroups = computed(() =>
      hasPermission(modelPermissionsGroupPermissionsConst.view)
    );
    const canViewI18nTranslations = computed(() =>
      hasPermission(i18nTranslationPermissionsConst.view)
    );
    const canViewTranslations = computed(() =>
      hasPermission(translationPermissionsConst.view)
    );
    const canViewInvoices = computed(() =>
      hasPermission(invoicePermissionsConst.view)
    );
    const canViewOrders = computed(() =>
      hasPermission(orderPermissionsConst.view)
    );
    const canSendOrders = computed(() =>
      hasPermission(orderPermissionsConst.send)
    );
    const canViewFiles = computed(() =>
      hasPermission(filePermissionsConst.view)
    );
    const canViewProcesses = computed(() =>
      hasPermission(processPermissionsConst.view)
    );
    const canViewAllegroAccounts = computed(() =>
      hasPermission(allegroAccountPermissionsConst.view)
    );
    const canViewAdmins = computed(() =>
      hasPermission(adminPermissionsConst.view)
    );
    const canViewClients = computed(() =>
      hasPermission(clientPermissionsConst.view)
    );
    const canViewIps = computed(() =>
      hasPermission(allowedIpPermissionsConst.view)
    );
    const canViewDiscountGroups = computed(() =>
      hasPermission(discountGroupPermissionsConst.view)
    );
    const canViewVariables = computed(() =>
      hasPermission(variablePermissionsConst.view)
    );
    const canViewSettings = computed(() =>
      hasPermission(settingPermissionsConst.view)
    );
    const canViewSystemLogs = computed(() =>
      hasPermission(systemLogPermissionsConst.view)
    );
    // The stats sub-tree is gated as a whole in the old panel - its four leaves
    // carry no permission check of their own.
    const canViewStats = computed(() =>
      hasPermission(statsPermissionsConst.view)
    );
    const canViewProductionLogs = computed(() =>
      hasPermission(statsPermissionsConst.productionLogs)
    );
    const canViewMessages = computed(() =>
      hasPermission(clientcontactPermissionsConst.view)
    );
    const canViewNews = computed(() =>
      hasPermission(newsPermissionsConst.view)
    );
    const canViewBanners = computed(() =>
      hasPermission(bannerPermissionsConst.view)
    );
    const canViewPages = computed(() =>
      hasPermission(pagePermissionsConst.view)
    );
    const canViewFaq = computed(() => hasPermission(faqPermissionsConst.view));
    const canViewCategories = computed(() =>
      hasPermission(categoryPermissionsConst.view)
    );
    const canViewProducts = computed(() =>
      hasPermission(productPermissionsConst.view)
    );
    const canViewParameters = computed(() =>
      hasPermission(productParameterPermissionsConst.view)
    );
    const canViewFormatGroups = computed(() =>
      hasPermission(formatGroupPermissionsConst.view)
    );
    const canViewFormats = computed(() =>
      hasPermission(formatPermissionsConst.view)
    );
    const canViewOptionGroups = computed(() =>
      hasPermission(productOptionGroupPermissionsConst.view)
    );
    const canViewExclusions = computed(() =>
      hasPermission(exclusionPermissionsConst.view)
    );
    const canViewDiscounts = computed(() =>
      hasPermission(discountPermissionsConst.view)
    );
    const canViewPackages = computed(() =>
      hasPermission(packagePermissionsConst.view)
    );
    const canViewAppliances = computed(() =>
      hasPermission(appliancesPermissionsConst.view)
    );
    const canViewCompetencies = computed(() =>
      hasPermission(competencePermissionsConst.view)
    );
    const canViewHolidays = computed(() =>
      hasPermission(holidayPermissionsConst.view)
    );
    const canViewMachines = computed(() =>
      hasPermission(machinePermissionsConst.view)
    );
    const canViewPlates = computed(() =>
      hasPermission(platePermissionsConst.view)
    );
    const canViewMontages = computed(() =>
      hasPermission(montagePermissionsConst.view)
    );
    // Production cubes are process stages in the old panel.
    const canViewCubes = computed(() =>
      hasPermission(processStagePermissionsConst.view)
    );
    const canImportPayments = computed(() =>
      hasPermission(paymentImportPermissionsConst.view)
    );
    const canViewCosts = computed(() =>
      hasPermission(costPermissionsConst.view)
    );
    const canViewTrackingTags = computed(() =>
      hasPermission(trackingTagPermissionsConst.view)
    );
    const canViewDynamicPrices = computed(() =>
      hasPermission(turnoverDiscountSettingPermissionsConst.view)
    );

    // A top level tab is only worth showing when the user can reach at least
    // one of the entries inside it - otherwise it expands into nothing.
    const anyOf = (...flags) =>
      computed(() => flags.some((flag) => flag.value));

    const canViewSaleMenu = anyOf(
      canViewOrders,
      canViewInvoices,
      canImportPayments
    );
    const canViewCrmMenu = anyOf(
      canViewClients,
      canViewMessages,
      canViewDiscountGroups
    );
    const canViewProductionMenu = anyOf(
      canViewMontages,
      canViewCubes,
      canSendOrders
    );
    const canViewProductsMenu = anyOf(
      canViewCategories,
      canViewProducts,
      canViewParameters,
      canViewFormatGroups,
      canViewFormats,
      canViewOptionGroups,
      canViewExclusions,
      canViewAppliances,
      canViewDiscounts
    );
    const canViewContentsMenu = anyOf(
      canViewNews,
      canViewBanners,
      canViewPages,
      canViewFaq,
      canViewTranslations,
      canViewI18nTranslations,
      canViewFiles
    );
    const canViewLogsMenu = anyOf(
      canViewStats,
      canViewSystemLogs,
      canViewProductionLogs
    );
    const canViewConfigurationMenu = anyOf(
      canViewAdmins,
      canViewGroups,
      canViewCompetencies,
      canViewIps,
      canViewSettings,
      canViewHolidays,
      canViewPackages,
      canViewMachines,
      canViewProcesses,
      canViewCosts,
      canViewPlates,
      canViewVariables,
      canViewTrackingTags,
      canViewKsefCompanies,
      canViewDynamicPrices
    );
    const canViewAllegroMenu = anyOf(canViewAllegroAccounts);

    const selectMenu = (item) => {
      if (selectedMenu.value.includes(item)) {
        let index = selectedMenu.value.indexOf(item);
        if (index > -1) {
          selectedMenu.value.splice(index, 1);
        }
      } else {
        selectedMenu.value.push(item);
      }
    };
    return {
      selectMenu,
      selectedMenu,
      userData,
      canViewKsefCompanies,
      canViewGroups,
      canViewI18nTranslations,
      canViewTranslations,
      canViewInvoices,
      canViewOrders,
      canSendOrders,
      canViewFiles,
      canViewProcesses,
      canViewAllegroAccounts,
      canViewAdmins,
      canViewClients,
      canViewIps,
      canViewDiscountGroups,
      canViewVariables,
      canViewSettings,
      canViewSystemLogs,
      canViewStats,
      canViewProductionLogs,
      canViewMessages,
      canViewNews,
      canViewBanners,
      canViewPages,
      canViewFaq,
      canViewCategories,
      canViewProducts,
      canViewParameters,
      canViewFormatGroups,
      canViewFormats,
      canViewOptionGroups,
      canViewExclusions,
      canViewDiscounts,
      canViewPackages,
      canViewAppliances,
      canViewCompetencies,
      canViewHolidays,
      canViewMachines,
      canViewPlates,
      canViewMontages,
      canViewCubes,
      canImportPayments,
      canViewCosts,
      canViewTrackingTags,
      canViewDynamicPrices,
      canViewSaleMenu,
      canViewCrmMenu,
      canViewProductionMenu,
      canViewProductsMenu,
      canViewContentsMenu,
      canViewLogsMenu,
      canViewConfigurationMenu,
      canViewAllegroMenu,
    };
  },
  computed: {},
};
</script>
